module.exports = __webpack_public_path__ + "img/logo2.9c5b86e7.png";